export const server =
    process.env.REACT_APP_ENV === 'production'
        ? 'https://dev.lsoft.net'
        : process.env.REACT_APP_ENV === 'staging'
        ? 'http://dev.lsoft.net'
        : 'http://localhost:4000';

export const secureServer =
    process.env.REACT_APP_ENV === 'production'
        ? 'https://secure.lsoft.net'
        : process.env.REACT_APP_ENV === 'staging'
        ? 'http://secure.lsoft.net'
        : 'http://localhost:58188';

export const webAPIUrl = `${server}/api`;
export const attachmentsUrl = `${server}/attachments/`;
export const tinymceKey = 'qutz8206qzbw7y81g6436ssgeely1iban0ce6wg1gt2zu7ab';

export const paypalClientId = 'AUjfovhneSc-HUDijx1vUdyWvMQBVaRvEKwwxnATgcg5foZV9sDW83r68ldxn4SCde94MwAH_gIAfuFO';
// export const paypalClientIdProd = 'AUjfovhneSc-HUDijx1vUdyWvMQBVaRvEKwwxnATgcg5foZV9sDW83r68ldxn4SCde94MwAH_gIAfuFO';
// export const paypalClientIdTest = 'AWqo_80z1MjgxLLYAH7mBrdkSdjDRBL5dnII3BNNYhRZdMgAwoOczDTwE6h3fRpy-kRKDef_3RyiBTT6';

export const LIFETIME_SUPPORT_YEARS = 20;
export const ANNUAL_SUPPORT_GENERAL = 15.0;
export const ANNUAL_SUPPORT_ID = 36;
export const ANNUAL_SUPPORT_NAME = 'Annual Support and Updates';
export const SITE_LICENSE = -1;
export const ENTERPRISE_LICENSE = -2;
export const UNLIMITED_LICENSE = -5;
export const ANNUAL_SUPPORT_SITE = 399.0;
export const ANNUAL_SUPPORT_ENTERPRISE = 799.0;
export const ANNUAL_SUPPORT_UNLIMITED = 499.0;
